// HomePage Content API
// Centralized content management for HomePage components

// Import images
import icon from '../images/icon/magic.png'
import hicon from '../images/icon/process-icon.svg'
import buildingIcon from '../images/icon/building.svg'
import starIcon from '../images/icon/star.svg'
import about1 from '../images/icon/magic.svg'
import about2 from '../images/icon/global.svg'
import about3 from '../images/icon/medal-star.svg'
import sIcon1 from '../images/icon/search01.svg'
import sIcon2 from '../images/icon/user-icon.png'
import sIcon3 from '../images/icon/clipboar02.svg'
import sIcon4 from '../images/icon/medal-star.svg'
import check from '../images/icon/check.svg'
import error from '../images/icon/erorr.svg'
import logo from '../images/logo/logo-white.svg'

// Hero Section Data - SEO + AEO Optimized
export const HeroContent = {
    badge: 'Rated 4.9/5 by 500+ enterprise clients',
    title: {
        line1: 'Custom Software Development',
        line2: 'That Scales Your Business'
    },
    // AEO: direct, answer-first value proposition (40-60 words, voice-search ready)
    subtitle: 'Bogin Tech builds enterprise-grade web apps, mobile apps, AI/ML automation, cloud platforms, and blockchain solutions. We help startups and Fortune 500 teams launch faster, cut costs, and scale securely — with measurable results in 90 days or less.',
    features: [
        'Custom web & mobile app development for enterprise',
        'AI/ML integration & GPT-powered automation',
        'Cloud, DevOps, blockchain, IoT & AR/VR engineering'
    ],
    cta: {
        text: 'Get Your Free Consultation',
        link: '/contact'
    },
    secondaryCta: {
        text: 'Explore Our Services',
        link: '/service'
    },
    chips: [
        { num: '90 Days', label: 'MVP to production' },
        { num: '99.9%', label: 'Uptime guaranteed' }
    ]
}

// Stats / Trust Band Data - AEO friendly proof points
export const StatsContent = {
    eyebrow: 'Proven Impact',
    title: 'Trusted technology partner delivering measurable business outcomes',
    stats: [
        { value: 500, suffix: '+', label: 'Enterprise clients worldwide' },
        { value: 750, suffix: '+', label: 'Projects delivered since 2020' },
        { value: 40, suffix: '%', label: 'Average cost reduction' },
        { value: 99.9, suffix: '%', label: 'Application uptime', decimals: 1 }
    ]
}

// About Section Data - SEO Optimized
export const AboutContent = {
    subtitle: 'Leading Software Development Company Since 2020',
    title: 'Expert Custom Software Development Services for Enterprise & Startups',
    principles: [
        {
            id: 1,
            icon: about1,
            label: 'Innovation-Driven Development:',
            description: 'Leveraging React, Next.js, Flutter, Node.js, Python AI/ML, Blockchain smart contracts, and AWS/Azure cloud platforms to build enterprise-grade software solutions that drive business growth.'
        },
        {
            id: 2,
            icon: about2,
            label: 'Client-Centric Approach:',
            description: 'Delivering custom enterprise software development, mobile app solutions, cloud migration services, and AI-powered automation tailored to your specific business requirements and industry needs.'
        },
        {
            id: 3,
            icon: about3,
            label: 'Proven Track Record:',
            description: 'Building secure, scalable software applications with 99.9% uptime, full GDPR/HIPAA compliance, and transparent agile development lifecycle management for startups to Fortune 500 companies.'
        }
    ],
    mission: {
        title: 'Our Mission: Transform Businesses Through Technology',
        description: 'We empower businesses worldwide with innovative custom software development, mobile application solutions, AI/ML integration, cloud infrastructure services, and emerging technologies like blockchain and IoT that accelerate digital transformation, improve operational efficiency, and create measurable competitive advantages in today\'s rapidly evolving digital marketplace.'
    },
    vision: {
        title: 'Our Vision: Leading the Future of Software Development',
        description: 'To be the world\'s most trusted technology partner for enterprises and startups seeking excellence in custom web development, mobile app engineering, artificial intelligence solutions, blockchain development, cloud computing, IoT implementation, and next-generation digital innovations that reshape industries and unlock unprecedented business potential.'
    },
    cta: {
        text: 'Explore Our Technology Solutions',
        link: '/about'
    },
    icons: {
        main: icon
    }
}

// Work Process Section Data - SEO Optimized
export const WorkProcessContent = {
    subtitle: 'Proven Agile Software Development Methodology Since 2020',
    title: 'Enterprise Software Development Process: From MVP to Production in 90 Days',
    steps: [
        {
            id: '01',
            title: 'Discovery & Technical Strategy (Week 1-2)',
            description: 'Comprehensive requirements analysis, technology stack selection (React, Node.js, Python, AWS/Azure), architecture planning, and project roadmap creation with detailed sprint planning and resource allocation',
            icon: sIcon1,
            direction: 'one'
        },
        {
            id: '02',
            title: 'UX/UI Design & System Architecture (Week 3-4)',
            description: 'Creating intuitive user experience designs, responsive interface mockups in Figma, robust microservices architecture, database schema design, API specifications, and comprehensive technical documentation for scalable cloud-native applications',
            icon: sIcon2,
            direction: 'two'
        },
        {
            id: '03',
            title: 'Agile Development & Quality Assurance (Week 5-10)',
            description: '2-week agile sprints with daily standups, continuous integration/continuous deployment (CI/CD), automated unit testing, integration testing, security vulnerability scanning, code reviews, and bi-weekly client demos with feedback incorporation',
            icon: sIcon3,
            direction: 'three'
        },
        {
            id: '04',
            title: 'Production Launch & Ongoing Support (Week 11-12+)',
            description: 'Zero-downtime deployment to AWS/Azure cloud infrastructure, performance monitoring setup, automated scaling configuration, comprehensive documentation delivery, team training, 24/7 technical support, monthly security patches, and continuous feature enhancements',
            icon: sIcon4,
            direction: 'four'
        }
    ],
    icons: {
        header: hicon
    }
}

// Industries Section Data - SEO Optimized
export const IndustriesContent = {
    subtitle: 'Enterprise Software Development Across 10+ Industries Since 2020',
    title: 'Custom Software Solutions Powering Innovation in SaaS, FinTech, HealthTech, LegalTech & More',
    cta: {
        text: 'Get Free Industry-Specific Consultation',
        link: '/contact'
    },
    icons: {
        header: buildingIcon
    }
}

// Features Section Data
export const FeaturesContent = {
    subtitle: 'Why Choose BoginTech',
    title: 'Comprehensive Technology Solutions',
    tableHeaders: {
        column1: 'Capabilities',
        column2Logo: logo,
        column3: 'Traditional IT Providers'
    },
    features: [
        {
            id: 1,
            capability: 'Full-stack web & mobile development',
            bogintech: true,
            traditional: false
        },
        {
            id: 2,
            capability: 'AI/ML & GPT integration expertise',
            bogintech: true,
            traditional: false
        },
        {
            id: 3,
            capability: 'React Native & Flutter mobile apps',
            bogintech: true,
            traditional: false
        },
        {
            id: 4,
            capability: 'Full infrastructure lifecycle transparency',
            bogintech: true,
            traditional: true
        },
        {
            id: 5,
            capability: 'Blockchain, IoT & AR/VR solutions',
            bogintech: true,
            traditional: false
        },
        {
            id: 6,
            capability: 'Agile development with rapid delivery',
            bogintech: true,
            traditional: false
        },
        {
            id: 7,
            capability: 'Dedicated project management & support',
            bogintech: true,
            traditional: false
        },
        {
            id: 8,
            capability: 'Multi-cloud architecture expertise',
            bogintech: true,
            traditional: true
        }
    ],
    icons: {
        header: starIcon,
        check: check,
        error: error
    }
}

// CTA Section Data - SEO Optimized
export const CTAContent = {
    title: 'Ready to Build Your Custom Software Solution in 2026?',
    subtitle: 'Transform your business with enterprise-grade web applications, mobile apps, AI/ML integration, cloud infrastructure, and blockchain development. Join 500+ companies who trust our expert software development team for scalable, secure, high-performance solutions.',
    cta: {
        text: 'Schedule Your Free Consultation Today',
        link: '/contact'
    }
}

// Export all content as a single object (optional convenience export)
const HomePageContent = {
    hero: HeroContent,
    about: AboutContent,
    workProcess: WorkProcessContent,
    industries: IndustriesContent,
    features: FeaturesContent,
    cta: CTAContent
}

export default HomePageContent;
